import $ from 'jquery';
import Player from '@vimeo/player';
import 'waypoints/lib/noframework.waypoints.min';

export default class Video {
    constructor() {
        if($('.js-video').length) {
            $('.js-video__play-button').on('click', function () {
                const $this = $(this);
                const $parent = $this.closest('.js-video');
                const $videoWrapper = $parent.find('.js-video__video');
                const videoSource = $videoWrapper.data('source');
                const $video = $videoWrapper.find('iframe');
                let width;
                let height;

                if(videoSource == 'vimeo') {
                    const player = new Player($video[0]);

                    Promise.all([player.getVideoWidth(), player.getVideoHeight()]).then(function(dimensions) {
                        width = dimensions[0];
                        height = dimensions[1];

                        if(height > width && Foundation.MediaQuery.is('small only')) {
                            $videoWrapper.removeClass('widescreen').addClass('portrait');
                        };

                        $this.fadeOut();

                        player.play();
                    });
                } else {
                    'use strict';

                    let $videoIframe = $video;
                    const currentSrc = $videoIframe.attr('src');

                    // Check if the autoplay parameter already exists to avoid duplication
                    if (currentSrc.indexOf('autoplay=') === -1) {
                        // Append &autoplay=1 to the src attribute value
                        const newSrc = currentSrc + '&autoplay=1';

                        // Set the modified src attribute back to the iframe
                        $videoIframe.attr('src', newSrc);
                    };

                    $this.fadeOut();

                    $videoWrapper.html($videoIframe);
                };
            });

            // Loop through each instance of the video block and check if it has the 'has-autoplay' class
            $('.js-video').each(function () {
                const $this = $(this);

                if ($this.hasClass('has-autoplay')) {
                    const $video = $this.find('.js-video__video iframe');
                    const player = new Player($video[0]);

                    player.setMuted(true);

                    new Waypoint({
                        element: $this[0],
                        handler: function () {
                            $this.find('.js-video__play-button').fadeOut();

                            player.play();
                        },
                        offset: 'bottom-in-view'
                    });
                };
            });
        };
    };
};
